<template>
	<div v-if="isVisible" class="px-4 formField">
		<v-menu
			:close-on-click="true"
			:close-on-content-click="false"
			:open-on-focus="true"
			offset-y
			v-model="menuStatus"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-text-field
					:disabled="formField.Readonly"
					@keyup="uppercase"
					:class="getUppercaseClass"
					v-model="selectedUserText"
					v-bind="attrs"
					v-on="on"
					:label="formField.Label"
					hide-details="auto"
					clearable
				>
					<template v-slot:append>
						<v-icon v-if="menuStatus">mdi-menu-up</v-icon>
						<v-icon v-else class="rotate">mdi-menu-up</v-icon>
					</template>
				</v-text-field>
			</template>
			<div v-if="menuStatus" style="background-color: white">
				<v-overlay absolute="absolute" :value="loading" :dark="false">
					<v-card max-width="200px">
						<v-card-text class="d-flex justify-center">
							<v-progress-circular
								:size="25"
								indeterminate
								color="primary"
							/>
							<span class="mx-3 text-button">Loading</span>
						</v-card-text>
					</v-card>
				</v-overlay>
				<v-row no-gutters class="mx-5" style="align-items: flex-end">
					<v-text-field
						@click:clear="onSearchClear"
						v-debounce:1000ms="onSearchChanged"
						append-icon="mdi-magnify"
						clearable
						v-model="search"
						hide-details="true"
						label="Search"
					></v-text-field>
				</v-row>

				<v-list max-height="300" style="overflow-y: scroll">
					<v-list-item-group
						v-model="selectedUser"
						active-class="primary white--text"
						class="field-list"
					>
						<v-list-item
							v-for="(item, index) in allUsers"
							@click.prevent="onSelectItem(item)"
							:key="index"
							:value="item"
							><v-list-item-content>
								<v-list-item-title>
									<span
										>{{ item.FirstName }}
										{{ item.LastName }}
									</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</div>
		</v-menu>
	</div>
</template>
<script>
import dataService from '../../../../services/data/projectGridsService';
import formFieldMixin from '../../../../mixins/inventoryForm/formFieldMixin';
import { GeneralActions } from '../../../../store/actions';
export default {
	name: 'UserField',
	mixins: [formFieldMixin],
	data() {
		return {
			menuStatus: false,
			selectedUser: null,
			allUsers: [],
			selectedUserText: null,
			loading: false,
			search: '',
			value: null,
		};
	},
	mounted() {
		if (this.record && this.key && this.record[this.key]) {
			this.value = this.record[this.key];
		}
		if (this.value != null) {
			this.loading = true;
			dataService
				.loadUserById(this.value)
				.then((response) => {
					this.selectedUser = response.data;
					this.selectedText(response.data);
					this.loading = false;
				})
				.catch((error) => {
					this.$store.dispatch(GeneralActions.ERROR, error);
					this.loading = false;
				});
		}
	},
	watch: {
		menuStatus(newVal) {
			if (!newVal) {
				this.search = null;
				return;
			}
			if (this.search === null) this.onSearchChanged();
		},
	},
	methods: {
		selectedText(item) {
			this.selectedUserText = item.FirstName.toString().concat(
				' ',
				item.LastName.toString()
			);
		},
		onRecordChanged() {
			if (
				this.recordSelectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = this.recordSelectedValue;
				return;
			}

			if (
				this.selectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = null;
			}
		},
		onSelectedValueChanged(newVal) {
			this.skipNextRecordUpdate = true;
			let id = null;
			if (newVal) {
				id = newVal.Id;
			}
			this.$emit('selectedValueChanged', [
				{ key: this.recordKeys[0], value: id },
			]);
		},
		onSelectItem(selectedRow) {
			this.selectedUser = selectedRow;
			this.selectedText(selectedRow);
			this.onSelectedValueChanged(selectedRow);
		},
		onSearchChanged() {
			this.loading = true;
			dataService
				.loadUsers(this.search)
				.then((response) => {
					this.allUsers = response.data;
					this.loading = false;
				})
				.catch((error) => {
					this.loading = false;
					this.$store.dispatch(GeneralActions.ERROR, error);
				});
		},
		onClear() {
			this.selectedUser = null;
		},
		onSearchClear() {
			this.search = null;
			this.onSearchChanged();
		},
		onSetInteraction(setValue) {
			this.onSelectedValueChanged(setValue);
		},
		onClearInteraction() {
			this.onSelectedValueChanged(null);
		},
	},
};
</script>
<style lang="scss">
.rotate {
	transform: rotate(180deg);
}
.v-menu__content {
	background-color: white;
}
</style>
